import { render } from "./helpPassosAhp.vue?vue&type=template&id=5c470f6f"
import script from "./helpPassosAhp.vue?vue&type=script&lang=js"
export * from "./helpPassosAhp.vue?vue&type=script&lang=js"

import "./helpPassosAhp.vue?vue&type=style&index=0&id=5c470f6f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__